module.exports = __webpack_public_path__ + "static/media/logo.9706b6d0.png";